import axios from 'axios';
import LaravelRouter from '../thirdparty/Ziggy/route.js';

const apiPost = function(route_name, route_args, args) {
    args = args ? args : null;
    return new Promise((success, error) => {
        let route = LaravelRouter(route_name, route_args, true);
        axios.post(route, args).then(response => {
            if (response && response.data) {
                success(response.data)
            } else {
                error(response);
            }
        }).catch(response => {
            error(response);
        });
    });
};
const apiGet = function(route_name, route_args, args, cancelToken = axios.CancelToken.source()) {
    args = args ? {params: args, cancelToken: cancelToken.token} : null;
    return new Promise((success, error) => {
        let route = LaravelRouter(route_name, route_args, true);
        axios.get(route, args).then(response => {
            if (response && response.data && response.data) {
                success(response.data)
            } else {
                error(response);
            }
        }).catch(response => {
            error(response);
        });
    });
};

export default {
    index(resource, args, cancelToken = axios.CancelToken.source()) {
        return apiGet(`${resource}.index`, [], args, cancelToken);
    },
    store(resource, args) {
        return apiPost(`${resource}.store`, [], args);
    },
    post(route_name, route_args, args) {
        return apiPost(route_name, route_args, args);
    },
    get(route_name, route_args, args, cancelToken = axios.CancelToken.source()) {
        return apiGet(route_name, route_args, args, cancelToken);
    },
    destroy(resource, id) {
        return new Promise((success, error) => {
            let route = LaravelRouter(`${resource}.destroy`, id, true);
            axios.delete(route).then(response => {
                if (response && response.data && response.data) {
                    success(response.data)
                } else {
                    error(response);
                }
            }).catch(response => {
                error(response);
            });
        });
    },
    update(resource, args, id) {
        return new Promise((success, error) => {
            let route = LaravelRouter(`${resource}.update`, id, true);
            axios.patch(route, args).then(response => {
                if (response && response.data && response.data) {
                    success(response.data)
                } else {
                    error(response);
                }
            }).catch(response => {
                error(response);
            });
        });
    },
}



// WEBPACK FOOTER //
// ./resources/js/api/api_resource.js